// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".context-panel-menu{z-index:70001}.context-panel-menu .context-panel{border-radius:9px;display:flex}.context-panel-menu .context-panel:not(.first-class-metrics-enabled){height:331px}.context-panel-menu .context-panel.first-class-metrics-enabled{max-height:331px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
